const SecretKey = {
    Key: "SmmAuthorization20230411"
}
export default SecretKey;